import { render, staticRenderFns } from "./projectM.vue?vue&type=template&id=f120f230&scoped=true&"
import script from "./projectM.vue?vue&type=script&lang=js&"
export * from "./projectM.vue?vue&type=script&lang=js&"
import style0 from "./projectM.vue?vue&type=style&index=0&id=f120f230&lang=scss&scoped=true&"
import style1 from "./projectM.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f120f230",
  null
  
)

export default component.exports